import { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useData } from "../../contexts/DataContext";
import { Search } from "lucide-react";
import { STATUS_META } from "../ui-bits";

export default function GlobalSearch() {
  const { tasks } = useData();
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const results = useMemo(() => {
    if (!query.trim()) return [];
    const q = query.toLowerCase();
    return tasks.filter((t) => !t.parent_id && t.title.toLowerCase().includes(q)).slice(0, 8);
  }, [query, tasks]);

  const openResult = (task) => {
    setQuery("");
    navigate(`/project/${task.project_id}?task=${task.id}`);
  };

  return (
    <div className="relative ml-4 flex-1 max-w-md">
      <Search size={15} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground" />
      <input data-testid="global-search-input" value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search tasks…"
        className="w-full h-8 pl-8 pr-3 text-sm rounded-md border border-border bg-surface focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary" />
      {results.length > 0 && (
        <div className="absolute top-9 left-0 right-0 bg-background border border-border rounded-md shadow-md z-50 py-1" data-testid="global-search-results">
          {results.map((t) => (
            <button key={t.id} data-testid={`search-result-${t.id}`} onClick={() => openResult(t)}
              className="w-full flex items-center gap-2 px-3 py-1.5 text-sm hover:bg-muted text-left">
              <span className="h-2 w-2 rounded-full shrink-0" style={{ backgroundColor: STATUS_META[t.status]?.color }} />
              <span className="truncate">{t.title}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
